var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgBulbPointerIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13.653,
    viewBox: "0 0 14 13.653",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icn-info",
    d: "M92.875,116.657l-.353-.774-.774-.353.774-.353.353-.774.353.774.774.353-.774.353Zm-1.931-2.649-.537-1.159-1.159-.537,1.159-.537.537-1.159.537,1.159,1.159.537-1.159.537Zm-6.437,10.262a1.175,1.175,0,0,1-.841-.338,1.211,1.211,0,0,1-.384-.826h2.451a1.211,1.211,0,0,1-.384.826A1.175,1.175,0,0,1,84.507,124.269Zm-2.414-2.055v-.965h4.828v.965Zm.1-1.857a4.681,4.681,0,0,1-1.6-1.643,4.506,4.506,0,1,1,7.832,0,4.681,4.681,0,0,1-1.6,1.643Zm.287-.965h4.055a3.571,3.571,0,0,0,1.118-1.271,3.465,3.465,0,0,0,.394-1.625,3.54,3.54,0,1,0-7.08,0,3.465,3.465,0,0,0,.394,1.625A3.571,3.571,0,0,0,82.479,119.392ZM84.507,119.392Z",
    transform: "translate(-80.001 -110.616)",
    fill: "#8d8d8d"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBulbPointerIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/bulbPointerIcon.35b9e208.svg";
export { ForwardRef as ReactComponent };